import type { MyUserViewModel, RoleModel } from '../../services';
import type { RowData } from './types';

export const getRoleOptions = (roles?: RoleModel[]) => {
  if (!roles) return [];

  return roles.map(role => ({
    label: role.description,
    value: role.name,
    key: role.name,
  }));
};

export const moveUserToFront = (user: MyUserViewModel, users: RowData[]) => {
  return [...users].sort(u => (u.id === user.id ? -1 : 0));
};
